/**
 * Microsoft Azure AD Authentication Configuration
 * Handles MSAL configuration for organizational accounts
 */

// Get configuration from environment variables
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';
const REDIRECT_URI = typeof window !== 'undefined' 
  ? `${window.location.origin}/login`
  : '';

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    navigateToLoginRequestUrl: false, // Don't navigate back, we handle it ourselves
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // Enable for IE11/Edge compatibility
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: // Error
            console.error('[MSAL]', message);
            break;
          case 1: // Warning
            console.warn('[MSAL]', message);
            break;
          case 2: // Info
            console.info('[MSAL]', message);
            break;
          case 3: // Verbose
            console.debug('[MSAL]', message);
            break;
          default:
            break;
        }
      },
      logLevel: 2, // Info level for more details
    },
  },
};

// Login request scopes - minimal scopes for authentication
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Check if Microsoft auth is configured
export const isMicrosoftAuthEnabled = () => {
  return Boolean(AZURE_CLIENT_ID && AZURE_TENANT_ID);
};

export default msalConfig;
